/**
 * Phase E — minimal Vuex modules for /assessment-results (and localized paths).
 * Other candidate flows keep the full module set in the router guard.
 */

/** Modules required for results first paint + getSummaries / enrichment. */
export const ASSESSMENT_RESULTS_ROUTE_MODULES = [
  "user",
  "team",
  "assessment",
  "assessmentSection",
  "assessmentTemplate",
  // MainCardResults builds the candidate's Big Five card from this module.
  "big5",
] as const;

/** Full set for assessment-test, /assessments/candidate, group analytics, etc. */
export const CANDIDATE_ASSESSMENT_ROUTE_MODULES = [
  "routes",
  "user",
  "team",
  "assessment",
  "assessmentSection",
  "assessmentTemplate",
  "respondent",
  "big5",
] as const;

export type AssessmentResultsRouteModule =
  (typeof ASSESSMENT_RESULTS_ROUTE_MODULES)[number];

export type CandidateAssessmentRouteModule =
  (typeof CANDIDATE_ASSESSMENT_ROUTE_MODULES)[number];

/**
 * The public report share route (and its locale twins). It renders
 * AssessmentResults.vue, so it needs exactly the same modules — but it is a
 * separate, exact-match path rather than a substring, so no other route can
 * accidentally opt into it.
 */
export function isReportSharePath(path: string): boolean {
  const normalized = path.toLowerCase().replace(/\/+$/, "");
  return (
    normalized === "/report" ||
    normalized === "/th/report" ||
    normalized === "/en/report"
  );
}

export function isAssessmentResultsRoutePath(path: string): boolean {
  return (
    path.toLowerCase().includes("/assessment-results") ||
    isReportSharePath(path)
  );
}
